import type { ComponentType } from 'react';
import {
  Globe, FileText, Shield, Clock, Heart, Target, Lightbulb, Users,
  Briefcase, GraduationCap, DollarSign, CheckCircle,
  Award, Star, MapPin, Home, Building, Book, Compass, Zap, Lock,
  Smile, ThumbsUp, TrendingUp, HelpCircle, Plane, Phone, Mail
} from 'lucide-react';

type IconComponent = ComponentType<{ className?: string }>;

export const ICON_CATALOG: Record<string, IconComponent> = {
  Globe, FileText, Shield, Clock, Heart, Target, Lightbulb, Users,
  Briefcase, GraduationCap, DollarSign, CheckCircle,
  Award, Star, MapPin, Home, Building, Book, Compass, Zap, Lock,
  Smile, ThumbsUp, TrendingUp, HelpCircle, Plane, Phone, Mail
};

export const ICON_NAMES = Object.keys(ICON_CATALOG);

export function resolveIcon(name?: string): IconComponent {
  return (name && ICON_CATALOG[name]) || HelpCircle;
}
